import firebase from "firebase/app";
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/database'

const firebaseConfig = {
    apiKey: process.env.VUE_APP_APIKEY,
    authDomain: process.env.VUE_APP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_DATABASEURL,
    projectId: process.env.VUE_APP_PROJECTID,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APPID,
    measurementId: process.env.VUE_APP_MEASUREMENTID,
};

firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
const firestoreStatic = firebase.firestore;

const auth = firebase.auth()
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .catch(error => {
       window.console.error("auth setPersistence", error)
    });

const storage = firebase.storage();
const db = firebase.database();
const dbStatic = firebase.database;

export {
    firestore,
    firestoreStatic,
    auth,
    storage,
    db,
    dbStatic,
}
